var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"buy-button",attrs:{"disabled":false},on:{"click":_vm.add}},[(_vm.innerQuantityCart > 0)?_c('i',{staticClass:"fas fa-check"}):[_vm._v("+")],_c('i',{staticClass:"fas fa-shopping-cart"})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }